import { inject, Injectable } from "@angular/core";
import { Store } from '@ngrx/store';
import { AuthServiceFacade } from "./auth-service-facade.service";

@Injectable({
    providedIn: 'root',
})
export class SasProvider {

    private readonly auth = inject(AuthServiceFacade);

    readonly sas$ = this.auth.sas$;

    constructor(private readonly store: Store) {
    }
}
